module.exports = __webpack_public_path__ + "static/media/warning-yellow.fd7fdd5e.svg";